import { allTrackers } from "app/services/track/track";

function createFullEventName(eventName: string, eventSubName?: string, eventSubSubName?: string) {
    return [eventName, eventSubName, eventSubSubName].filter(Boolean).join("/");
}

export function trackPopupOpen(eventType: "create" | "edit") {
    const eventName = createFullEventName(
        eventType === "create" ? "Create New Keyword Group" : "edit keyword group",
        "open",
    );
    allTrackers.dispatchTrackEvent("Pop Up", "open", eventName);
}

function trackPopupClose(type: "Go back" | "Discard changes") {
    const eventName = createFullEventName("Create New Keyword Group", "leave", type);
    allTrackers.dispatchTrackEvent("Pop Up", "close", eventName);
}

type ClickEvent =
    | { event: "Cancel" }
    | { event: "Save"; keywordListName: string }
    | { event: "Add Keyword"; keyword: string }
    | { event: "Load Suggestions"; seedKeyword: string }
    | { event: "Country Filter"; countryName: string }
    | { event: "Paste Keywords"; count: number }
    | { event: "delete"; count: number }
    | { event: "check"; count: number }
    | { event: "uncheck"; count: number }
    | { event: "leave"; value: "Go back" | "Discard changes" };

function getClickEventSubNames(trackEvent: ClickEvent): [string, string | undefined] {
    switch (trackEvent.event) {
        case "Cancel":
            return [trackEvent.event, undefined];
        case "Save":
            return [trackEvent.event, trackEvent.keywordListName];
        case "Add Keyword":
            return [trackEvent.event, trackEvent.keyword];
        case "Paste Keywords":
            return [trackEvent.event, trackEvent.count.toString()];
        case "Load Suggestions":
            return [trackEvent.event, trackEvent.seedKeyword];
        case "Country Filter":
            return [trackEvent.event, trackEvent.countryName];
        case "delete":
            return [trackEvent.event, trackEvent.count > 1 ? "multiple" : "single"];
        case "check":
        case "uncheck":
            return [trackEvent.event, trackEvent.count > 1 ? "all matching" : "single"];
        case "leave":
            return [trackEvent.event, trackEvent.value];
    }
}

export function trackPopupClick(trackEvent: ClickEvent) {
    const [subName, subSubName] = getClickEventSubNames(trackEvent);
    const eventName = createFullEventName("Create New Keyword Group", subName, subSubName);

    allTrackers.dispatchTrackEvent("Pop Up", "click", eventName);
}
